<template>
  <Catalogs
    title="Источник исполнителей"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'WorkerSourceAdd'"
    :route-edit="'WorkerSourceEdit'"
    :route-view="'WorkerSourceView'"
    :route-path="'/worker_sources'"
    :can-edit="canEditWorkerSourceCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkerSources",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getWorkerSources(data);
    },
    canEditWorkerSourceCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORKER_SOURCE_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerSources/WorkerSources.vue